import React from "react"
import { IconProps } from "./types"

export const CurrierIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.86 18.5" {...props}>
      <g>
        <path
          d="M34.75,12.42l-2.9-7.01c-0.28-0.97-1.18-1.65-2.19-1.65h-2.59V1.3c0-0.72-0.58-1.3-1.3-1.3H7.9C7.19,0,6.6,0.58,6.6,1.3
            v4.64H4.65c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h9.07c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H7.6V1.3
            C7.6,1.13,7.74,1,7.9,1h17.87c0.17,0,0.3,0.13,0.3,0.3v3.46h3.59c0.57,0,1.07,0.38,1.25,0.98l2.9,7.01
            c0.03,0.12,0.05,0.23,0.05,0.35c0,0.7-0.57,1.28-1.28,1.28h-4.41l-0.02,0.48c-0.06,1.43-1.22,2.59-2.65,2.65
            c-1.56,0.07-2.8-1.13-2.86-2.65l-0.02-0.48h-6.24l-0.02,0.48c-0.06,1.43-1.22,2.59-2.65,2.65c-0.76,0.04-1.44-0.23-1.98-0.73
            c-0.54-0.5-0.85-1.18-0.88-1.92l-0.02-0.48H7.9c-0.17,0-0.3-0.13-0.3-0.3v-2.36c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5v2.36
            c0,0.72,0.58,1.3,1.3,1.3h2.01c0.14,0.82,0.54,1.56,1.15,2.13c0.74,0.68,1.7,1.03,2.7,1c1.78-0.07,3.26-1.41,3.56-3.13h4.38
            c0.14,0.82,0.54,1.56,1.15,2.13c0.7,0.65,1.6,1,2.55,1c0.05,0,0.1,0,0.15,0c1.78-0.07,3.26-1.41,3.56-3.13h3.48
            c1.26,0,2.28-1.02,2.28-2.28C34.86,12.89,34.83,12.68,34.75,12.42z"
        />
        <path d="M2.92,8.9h8.67c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H2.92c-0.28,0-0.5,0.22-0.5,0.5S2.65,8.9,2.92,8.9z" />
        <path
          d="M10.6,10.37c0-0.28-0.22-0.5-0.5-0.5H0.5c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h9.6
            C10.38,10.87,10.6,10.64,10.6,10.37z"
        />
      </g>
    </svg>
  )
}
